import { DBCollection } from '@/lib/utils/constants-shared';
import { BIBLE_BOOKS_SORT_ORDER } from '@/lib/utils/bible-utils';
import { fetchItemsFromDB } from '@/lib/utils/db-service';
import type { Auth } from 'firebase/auth';
import { collection, type Firestore, query, type Timestamp } from 'firebase/firestore';


export async function fetchLiteraryFeaturesFromDB(auth: Auth, db: Firestore): Promise<LiteraryFeaturesByBook[]> {
    const dataQuery = query(collection(db, DBCollection.literaryFeaturesByBook));
    const items = await fetchItemsFromDB<FirebaseLiteraryFeatures<Timestamp>>(dataQuery);
    return items.map(item => ({
        ...item,
        dateCreated: item.dateCreated.toDate(),
        dateUpdated: item.dateUpdated.toDate()
    }));
}

export function sortLiteraryFeatures(items: LiteraryFeaturesByBook[]): LiteraryFeaturesByBook[] {
    return [...items].sort((a, b) => {
        return BIBLE_BOOKS_SORT_ORDER[a.book] < BIBLE_BOOKS_SORT_ORDER[b.book] ? -1 : 1;
    });
}

export function getLiteraryFeaturesByBook(items: LiteraryFeaturesByBook[]): Map<string, LiteraryFeaturesByBook[]> {
    const map = new Map<string, LiteraryFeaturesByBook[]>();
    items.forEach(item => {
        const existing = map.get(item.book) || [];
        map.set(item.book, [...existing, item]);
    });
    return map;
}